import React from "react";

import DotsHorizontal from "@uui/DotsHorizontal";

import AccordionDetails, {
  AccordionDetailsProps,
} from "@mui/material/AccordionDetails";
import styled from "@mui/material/styles/styled";

import Accordion, { AccordionProps, AccordionSummary } from "@rui/Accordion";
import IconButton, { IconButtonProps } from "@rui/IconButton";
import { Column, Row } from "@rui/Stack";

import { Card } from "../styles";

export const Panel = styled(Card)({
  width: "300px",
  flexShrink: 1,
});

export const DetailsPanelContent = styled(Column)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: theme.palette.background.default,
  color: theme.palette.shades.neutral[700],
  overflowY: "auto",
}));

export const DetailsPanelFooter = styled(Row)(({ theme }) => ({
  minHeight: "58px",
  backgroundColor: "#FFF",
  padding: theme.spacing(1.5),
  borderTop: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  columnGap: "16px",
}));

type DetailsPanelFooterButton = IconButtonProps & {
  shape?: "round" | "square";
};

export const DetailsPanelFooterButton = styled<
  React.FC<DetailsPanelFooterButton>
>(({ shape: _s, ...props }) => <IconButton {...props} />)(({ shape }) => ({
  height: "32px",
  width: "32px",
  borderRadius: shape === "round" ? "50%" : undefined,
  "& .MuiSvgIcon-root": {
    fontSize: "20px",
  },
}));

type ContextAccordionProps = Omit<AccordionProps, "children"> & {
  children: AccordionDetailsProps["children"];
};

export const ContextAccordion = styled<React.FC<ContextAccordionProps>>(
  ({ children, ...props }) => (
    <Accordion {...props}>
      <AccordionSummary iconSize="14px">Context</AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
)(({ theme }) => ({
  background: "none",
  "& .MuiAccordionSummary-root": {
    fontSize: "0.875rem",
    fontWeight: 500,
    minHeight: 0,
    padding: theme.spacing(1, 0, 0),
    justifyContent: "flex-start",
    columnGap: "4px",
  },
  "& .MuiAccordionSummary-content": {
    flexGrow: "unset",
    margin: 0,
  },
  "& .MuiAccordionDetails-root": {
    padding: theme.spacing(1, 0, 0),
  },
}));

export const ActionsMenuButton = (props: IconButtonProps) => (
  <DetailsPanelFooterButton {...props}>
    <DotsHorizontal />
  </DetailsPanelFooterButton>
);
